/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LocationFilterSchemaCategory } from './locationFilterSchemaCategory';
import type { LocationFilterSchemaMode } from './locationFilterSchemaMode';
import type { LocationFilterSchemaScope } from './locationFilterSchemaScope';

export interface LocationFilterSchema {
  country?: string | null;
  region?: string | null;
  locality?: string | null;
  lat?: number | null;
  lon?: number | null;
  distance?: string | null;
  category?: LocationFilterSchemaCategory;
  display_name?: string | null;
  required?: boolean;
  mode?: LocationFilterSchemaMode;
  scope?: LocationFilterSchemaScope;
}
